"use strict";

var resetPassWidget = function () {
  var isDialogOpen = false;
  var resetWidgetParams = {
    url: {}
  };

  function resetPass(data) {
    $.ajax({
      type: 'POST',
      url: resetWidgetParams.url.resetPassword,
      data: data,
      success: function success(data) {
        if (data.result == "ok" || !data.result || typeof data.result === "undefined") {
          //modalDialog.showInfo('Информация', data.message); 
          $("#info-modal-content").text(data.message);
          $("#info-modal").showAsModal({
            title: "Информация",
            buttons: [{
              title: 'Хорошо',
              primary: true,
              big: true
            }],
            afterClose: function afterClose() {
              isDialogOpen = false;
            }
          });
        } else {
          modalDialog.showBaseWnd({
            title: 'Ошибка восстановления',
            buttons: [{
              title: 'Хорошо',
              big: true,
              primary: true
            }],
            onClose: function onClose() {
              isDialogOpen = false;
            },
            onDrawContent: function onDrawContent() {
              return data.message;
            }
          });
        }
      },
      error: function error(data) {
        modalDialog.showBaseWnd({
          title: 'Ошибка восстановления',
          buttons: [{
            title: 'Хорошо',
            big: true,
            primary: true
          }],
          onClose: function onClose() {
            isDialogOpen = false;
          },
          onDrawContent: function onDrawContent() {
            return data.message;
          }
        });
      }
    });
  }

  function testEmail(email) {
    var reg = new RegExp('^([a-z0-9_-]+\.)*[a-z0-9_-]+@[a-z0-9_-]+(\.[a-z0-9_-]+)*\.[a-z]{2,6}$');
    return reg.test(email.toLowerCase());
  }

  function testPhone(phone) {
    var phoneRgx = /^((\+[\d]{1,3})[\- ]?)[\d]{6,12}$/;
    return phoneRgx.test(phone);
  }

  function formatPhoneNumber(phone) {
    return phone.replace(/[^+\d]/g, '');
  }

  function submitResetForm() {
    var login = $("#email").val().trim();

    if (!testEmail(login) && !testPhone(login)) {
      modalDialog.showBaseWnd({
        title: 'Неверный формат введенных данных',
        buttons: [{
          title: 'Хорошо',
          big: true,
          primary: true
        }],
        onDrawContent: function onDrawContent() {
          return 'Пожалуйста, проверьте корректность введенных данных';
        }
      });
      return;
    } else {
      if (testPhone(login)) {
        login = formatPhoneNumber(login);
      }

      var resetData = {
        mail: login
      };
      isDialogOpen = true;
      resetPass(resetData);
    }
  }

  function unbindHandlers() {
    $(document).off('click', '#resetPassBtn');
  }

  ;

  function bindHandlers() {
    $(document).on('keypress', function (e) {
      if (e.which === 13 && !isDialogOpen) {
        submitResetForm();
      }
    });
    $(document).on('click', '#resetPassBtn', function () {
      submitResetForm();
    });
  }

  ;

  function setParams(resetPasswordParams) {
    resetWidgetParams = $.extend({}, resetWidgetParams, resetPasswordParams);
  }

  function init(resetPasswordParams) {
    unbindHandlers();
    setParams(resetPasswordParams);
    bindHandlers();
  }

  return {
    init: init
  };
}();